import { jsx as h, Fragment as U } from "react/jsx-runtime";
import C, { useRef as z, useCallback as l, useEffect as D } from "react";
import { useFoundation as L, emptyClientRect as O, matches as V, classNames as k } from "@rmwc/base";
import { useProviderContext as F } from "@rmwc/provider";
import { MDCRippleFoundation as M, util as $ } from "@material/ripple";
const j = (t) => {
  const d = z(!1), { foundation: n, ...i } = L({
    props: t,
    elements: {
      rootEl: !0,
      surfaceEl: !0
    },
    foundation: ({ rootEl: e, surfaceEl: x, getProps: S }) => new M({
      addClass: (r) => {
        x.addClass(r);
      },
      browserSupportsCssVars: () => $.supportsCssVariables(window),
      computeBoundingRect: () => e.ref ? e.ref.getBoundingClientRect() : O,
      containsEventTarget: (r) => !!e.ref && e.ref.contains(r),
      deregisterDocumentInteractionHandler: (r, m) => document.documentElement.removeEventListener(r, m),
      deregisterInteractionHandler: (r, m) => {
      },
      deregisterResizeHandler: (r) => window.removeEventListener("resize", r),
      getWindowPageOffset: () => ({
        x: window.pageXOffset,
        y: window.pageYOffset
      }),
      isSurfaceActive: () => e.ref ? V(e.ref, ":active") : !1,
      isSurfaceDisabled: () => !!S().disabled,
      removeClass: (r) => {
        x.removeClass(r);
      },
      isUnbounded: () => !!S().unbounded,
      registerDocumentInteractionHandler: (r, m) => document.documentElement.addEventListener(r, m, {
        passive: !0
      }),
      registerInteractionHandler: (r, m) => {
      },
      registerResizeHandler: (r) => window.addEventListener("resize", r),
      updateCssVariable: (r, m) => x.setStyle(r, m)
    })
  }), { rootEl: a } = i, s = l(
    (e) => {
      e.persist(), n.activate(e);
    },
    [n]
  ), o = l(
    (e) => {
      e.persist(), n.deactivate();
    },
    [n]
  ), { onFocus: p } = t, b = l(
    (e) => {
      p == null || p(e), n.handleFocus();
    },
    [n, p]
  ), { onBlur: c } = t, g = l(
    (e) => {
      c == null || c(e), n.handleBlur();
    },
    [n, c]
  ), { onMouseDown: w } = t, u = l(
    (e) => {
      w == null || w(e), d.current || s(e), d.current = !1;
    },
    [w, s]
  ), { onMouseUp: y } = t, E = l(
    (e) => {
      y == null || y(e), o(e);
    },
    [y, o]
  ), { onTouchStart: f } = t, v = l(
    (e) => {
      d.current = !0, f == null || f(e), s(e);
    },
    [f, s]
  ), { onTouchEnd: R } = t, T = l(
    (e) => {
      R == null || R(e), o(e);
    },
    [R, o]
  ), { onKeyDown: N } = t, B = l(
    (e) => {
      N == null || N(e), s(e);
    },
    [N, s]
  ), { onKeyUp: P } = t, I = l(
    (e) => {
      P == null || P(e), o(e);
    },
    [P, o]
  );
  return a.setProp("onFocus", b, !0), a.setProp("onBlur", g, !0), a.setProp("onMouseDown", u, !0), a.setProp("onMouseUp", E, !0), a.setProp("onTouchStart", v, !0), a.setProp("onTouchEnd", T, !0), a.setProp("onKeyDown", B, !0), a.setProp("onKeyUp", I, !0), D(() => {
    n.setUnbounded(!!t.unbounded);
  }, [t.unbounded, n]), D(() => {
    t.disabled && n.handleBlur();
  }, [t.disabled, n]), { ...i };
}, H = C.createContext({});
function K(t) {
  const {
    children: d,
    className: n,
    primary: i,
    accent: a,
    unbounded: s,
    surface: o,
    foundationRef: p,
    ...b
  } = t, { rootEl: c, surfaceEl: g } = j(t), w = F(), u = C.Children.only(d);
  if (!w.ripple)
    return /* @__PURE__ */ h(U, { children: d });
  if (!C.isValidElement(u))
    return null;
  const y = !o || !s, E = s ? { "data-mdc-ripple-is-unbounded": !0 } : {}, f = y ? g.props({ style: u.props.style }) : {};
  let v = k(
    n !== u.props.className && n,
    f.className,
    u.props.className,
    {
      "mdc-ripple-surface": typeof o == "boolean" ? o : o === void 0,
      "mdc-ripple-surface--primary": i,
      "rmwc-ripple-surface--primary": i,
      "mdc-ripple-surface--accent": a,
      "rmwc-ripple-surface--accent": a
    }
  );
  b.disabled && (v = v.replace(
    "mdc-ripple-upgraded--background-focused",
    ""
  ));
  const R = C.cloneElement(u, {
    ref: c.reactRef,
    ...u.props,
    ...E,
    ...c.props({
      ...b,
      style: u.props.style,
      ...f,
      className: v
    })
  });
  return /* @__PURE__ */ h(
    H.Provider,
    {
      value: g.props({ style: u.props.style }),
      children: R
    }
  );
}
const G = ({
  className: t,
  ...d
}) => /* @__PURE__ */ h(H.Consumer, { children: (n) => /* @__PURE__ */ h(
  "div",
  {
    ...d,
    ...n,
    className: `${t} ${n.className || ""}`
  }
) }), J = ({
  unbounded: t,
  accent: d,
  surface: n
} = {}) => (i) => {
  const a = C.forwardRef(
    ({ ripple: s, ...o }, p) => {
      const b = F();
      s = s ?? b.ripple;
      const c = typeof s != "object" ? {} : s;
      return s ? /* @__PURE__ */ h(
        K,
        {
          ...o,
          accent: c.accent || d,
          unbounded: c.unbounded || t,
          surface: c.surface || n,
          children: /* @__PURE__ */ h(i, { ...o, ref: p })
        }
      ) : /* @__PURE__ */ h(i, { ...o, ref: p });
    }
  );
  return a.displayName = `withRipple(${i.displayName || i.constructor.name || "Unknown"})`, a;
};
export {
  K as Ripple,
  G as RippleSurface,
  J as withRipple
};
